$(() => {
    let segments = window.location.pathname.split('/').slice(1)
    let path = segments[0]

    if (1 < segments.length) {
        path = segments.slice(0, segments.length).join('/')
    }

    if (path) {
        let selectors = [
            '[id="menu"] a[href^="/' + path + '"]',
            '[id="submenu"] a[href^="/' + path + '"]',
        ]

        $(selectors.join(', ')).addClass('-current')
    } else {
        $('[id="menu"] a[href="/"]').addClass('-current')
    }
})
